export const TRUE_MED_WIDGET = 'js-truemed-widget';
